import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { FieldEventType } from '../models/field-event-type';
import { FieldEventColumnName } from '../models/field-event-column-name';
import { FieldEventColumnNameOptionDTO } from '../models/field-event-column-name-option';



@Injectable({
    providedIn: 'root'
})
export class FieldEventTypesService {
    protected basePath = '/';
    public deleteFieldEventColumnNamesArray = [];
    public updateFieldEventColumnsArray: FieldEventColumnName[] = [];
    public selectedFieldEventColumn = new BehaviorSubject<FieldEventColumnName | null>(null);
    public fieldEventColumnOptions = new BehaviorSubject<FieldEventColumnNameOptionDTO[]>([]);
    public pendingOptionMap = new Map<string, FieldEventColumnNameOptionDTO[]>();
    public pendingUpdatedOptionsMap = new Map<string, FieldEventColumnNameOptionDTO[]>();

    public deleteFieldEventColumnOptionIdsArray: number[] = [];
    public originalFieldEventColumnsMap = new Map<number, FieldEventColumnName>();
    public originalFieldEventColumnOptionsMap = new Map<number, FieldEventColumnNameOptionDTO>()
    public originalOptionMapForCancel = new Map<number, FieldEventColumnNameOptionDTO>();
    public pendingImageUploads = new Map<string, File>();

    constructor(
        protected httpClient: HttpClient,
        private authService: AuthService
    ) {
        this.basePath = environment.PLATFORM_API_URL;
    }

    public apiFieldEventTypesGet(): Observable<Array<FieldEventType>> {
        return this.httpClient.get<FieldEventType[]>(`${this.basePath}/api/FieldEventTypes`);
    }

    public apiFieldEventTypePost(body?: FieldEventType): Observable<FieldEventType> {
        return this.httpClient.post(`${this.basePath}/api/FieldEventTypes`, body);
    }
    public apiFieldEventTypePut(id: number, body?: FieldEventType): Observable<FieldEventType> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiFarmsByIdPut.');
        }

        return this.httpClient.put(`${this.basePath}/api/FieldEventTypes/${encodeURIComponent(String(id))}`, body);
    }
    public apiFieldEventTypesDelete(id: number): Observable<any> {
        

        return this.httpClient.delete(`${this.basePath}/api/FieldEventTypes/${id}`);
    }
    // fetch api 

    deleteFieldEventColumn(id: number): Observable<any> {
        return this.httpClient.delete(`${this.basePath}/api/FieldEventTypes/field-event-column/${id}`);
    }

    //#region 
    deletedIdForFieldEventColumnNames(id: number) {
        if (id) {
            this.deleteFieldEventColumnNamesArray.push(id);
        }
    }
    //#endregion


    //#region  detch edit api for the field-event-column  table

    public updateFieldEventColumn(id: number, column: FieldEventColumnName): Observable<FieldEventColumnName> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateFieldEventColumn.');
        }

        return this.httpClient.put<FieldEventColumnName>(
            `${this.basePath}/api/FieldEventTypes/field-event-column/${encodeURIComponent(String(id))}`,
            column
        );
    }

    //#endregion 

    //#region  fetch api  deleet FieldEventColumnNameOption Model 

    updateFieldEventColumnOption(optionId: number, option: FieldEventColumnNameOptionDTO): Observable<FieldEventColumnNameOptionDTO> {
        if (optionId === null || optionId === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateFieldEventColumn.');
        }

        return this.httpClient.put<FieldEventColumnNameOptionDTO>(
            `${this.basePath}/api/FieldEventTypes/field-event-column-option/${encodeURIComponent(String(optionId))}`,
            option
        );

    }

    //#endregion 

    //#region  fetch api  deleet FieldEventColumnNameOption Model 

    deleteFieldEventColumnOption(id: number): Observable<any> {
        return this.httpClient.delete(`${this.basePath}/api/FieldEventTypes/field-event-column-option/${id}`);
    }

    deletedIdForFieldEventColumnOptions(id: number) {
        if (!this.deleteFieldEventColumnOptionIdsArray.includes(id)) {
            this.deleteFieldEventColumnOptionIdsArray.push(id);
        }
    }
    //#endregion 
}

